
import makerjs from "makerjs";
/**
 * 计算两点间的弦长
 * @param {Object} p1 - 第一个点坐标 {x, y}
 * @param {Object} p2 - 第二个点坐标 {x, y}
 * @returns {number} 弦长值
 */
 function calculateChordLength(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx*dx + dy*dy);
}
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;

  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
    x: midX + h * ux,
    y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;

  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);

  return {
    x: center.x + sumX * invLen,
    y: center.y + sumY * invLen
  };
}
function C22(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
  W = Param[0].param,H = Param[1].param, R = Param[2].param,   
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r = R * 1 * myZoom,
    hh = H * 1 * myZoom,
    w = W * 1 * myZoom,
    h=w,
    rd=r/Math.sqrt(2),
    x0 = 0,  y0 = r,
    x1 = 0, y1 = w,
    x2 = hh,  y2 =w, 
    x3 = hh,  y3 = hh+r,
    x4 = hh+r,  y4 = hh,
    x5 = w,  y5 = hh,
    x6 = w,  y6 = 0,
    x7 = r,  y7 = 0,
    
     glassH = h, glassW = w;
 

  if (r !== 0) {
    var TxtR = "R1=" +R;
  } if (hh !== 0) {
    var TxtH ="H=" + H;
  } if (w !== 0) {
    var TxtW = "W=" + W;
  }



  var drawAbnormalShapeC22 = {
    paths: {
      "LeftLLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
      "LeftUpLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
      "LeftRLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
      "RightArcLine": new makerjs.paths.Arc([x3, y3], [x4, y4], r, false, false),
      "BottomUpLine": new makerjs.paths.Line([x4, y4], [x5, y5]),      
      "RightLine": new makerjs.paths.Line([x5, y5], [x6, y6]),         
      "BottomLine": new makerjs.paths.Line([x6, y6], [x7, y7]),      
      "LeftArcLine": new makerjs.paths.Arc([x7, y7], [x0, y0], r, false, true),
    }
  };
  var drawAbnormalShapeC22MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y7-markShift], [x6, y6-markShift]),
      "LeftShortLine": new makerjs.paths.Line([x0, y7], [x0, y7-2*markShift]),
      "RightShortLine": new makerjs.paths.Line([x6, y6], [x6, y6-2*markShift]),
    }
  };
  var drawAbnormalShapeC22MarkR = {
    paths: {
      "BottomLine": new makerjs.paths.Line([r-rd, r-rd], [rd, rd]),
    }
  };
  var drawAbnormalShapeC22MarkH = {
    paths: {
      "Line": new makerjs.paths.Line([x6+markShift, y6], [x5+markShift, y5]),
      "UpShortLine": new makerjs.paths.Line([x5, y5], [x5+3*markShift, y5]),
      "DnShortLine": new makerjs.paths.Line([x6, y6], [x6+3*markShift, y6]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC22MarkR, TxtR, [rd, rd], [rd+5*markShift, rd]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC22MarkW, TxtW, [x0, y7-3*markShift], [x6, y6-3*markShift]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC22MarkH, TxtH, [x6+3*markShift, y6], [x5+3*markShift, y5]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC22: drawAbnormalShapeC22,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC22: drawAbnormalShapeC22,
      drawAbnormalShapeC22MarkR: drawAbnormalShapeC22MarkR,
      drawAbnormalShapeC22MarkW: drawAbnormalShapeC22MarkW,
      drawAbnormalShapeC22MarkH: drawAbnormalShapeC22MarkH,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C22;